import {elementNameConst, shapeTypeConst} from '../../../conf';

/**
 * 拓扑插件-自定义单控制节点单弧度动画曲线-扩展
 */
export default {
  name: shapeTypeConst.quadraticCircleRunning,
  type: elementNameConst.edge,
  options: {
    /**
     * 绘制后的附加操作，默认没有任何操作
     * @param cfg 边的配置项
     * @param group 图形分组，边中的图形对象的容器
     */
    afterDraw(cfg, group) {
      // 获得组中的第一个形状，这是边的路径=
      const shape = group.getFirst();
      // 边缘路径的起始位置
      // const startPoint = shape.getPoint(0);
      const startPoint = cfg.startPoint;

      // 添加红色圆形
      const circle = group.addShape('circle', {
        attrs: {
          x: startPoint.x,
          y: startPoint.y,
          fill: '#1890ff',
          r: 2
        },
        name: 'quadratic-circle-shape'
      });

      // 动画配置
      const animateCfg = {
        // 是否重复执行动画
        repeat: true,
        // 执行一次的持续时间
        duration: 3000 
      };

      // 红色圆圈的动画
      circle.animate((ratio) => {
        // 每个帧中的操作。比率范围从0到1，表示动画的进度。返回修改后的配置
        // 根据比率获得边缘上的位置
        const tmpPoint = shape.getPoint(ratio);
        // 在此处返回修改后的配置，在此处返回x和y
        return {
          x: tmpPoint.x,
          y: tmpPoint.y
        };
      }, animateCfg);
    }
  },
  // 继承节点名
  extendedNodeName: shapeTypeConst.quadratic
};
